import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";
import { differenceInCalendarDays } from "date-fns";



export default class TAH extends Indicador {
    static get fullName() {
        return "Tempo de Aplicação de Herbicida";
    }

    static get abbrev() {
        return "TAH";
    }
    static get field() {
        return "TAH";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraEES: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",

            dataAplicacao: {
                newField: "dataAplicacao",
                convert: (dt) => {
                    if (dt) {
                        let pats = dt.split('/')
                        let data = new Date(pats[2], pats[1] - 1, pats[0])
                        return data;
                    } else {
                        return null
                    }
                },
            },
            dataColheita: {
                newField: "dataColheita",
                convert: (dt) => {
                    if (dt) {
                        let pats = dt.split('/')
                        let data = new Date(pats[2], pats[1] - 1, pats[0])
                        return data;
                    } else {
                        return null
                    }
                },
            },

            insumo: "insumo",
            dosagemRecomendada: "dosagemRecomendada",

            conformidadeAmostra: "conformidade",
            observacaoAmostra: "observacao",


            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {


            MetaTempoAplicacaoHerbicidaManual: "manual.meta",

            MetaTempoAplicacaoHerbicidaMecanizado: "mecanizado.meta",

        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat

        let conformidade = 0
        if (apontamento.dataColheita && apontamento.dataAplicacao) {

            // let diferenca = Math.abs(new Date(apontamento.dataColheita).getTime() - new Date(apontamento.dataAplicacao).getTime())
            // let diferenca = Math.abs(apontamento.dataColheita.getTime() - apontamento.dataAplicacao.getTime())
            // conformidade = Math.ceil(diferenca / (1000 * 60 * 60 * 24));
            conformidade = differenceInCalendarDays(
                new Date(apontamento.dataAplicacao),
                new Date(apontamento.dataColheita))

        }

        apontamento.acima = params?.meta && conformidade > f(params.meta) ? 1 : 0
        apontamento.abaixo = 0

        return conformidade;
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 121, 105.2, 89.42);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;


            if (this.calcPontoAmostradoColeta(item, apontamento.conformidade)) {
                count++;
            }


            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        let dosagemRecomendada = parseFloat(apontamento.dosagemRecomendada).toFixed(2)
        let insumo = parseFloat(apontamento.insumo).toFixed(2)

        return "Dose Recomendada: " + dosagemRecomendada +
            " e Insumo: " + insumo
    }
}
